import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-5 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "flex flex-col mb-4" }
const _hoisted_10 = { class: "uppercase text-sm m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4 mb-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4 mb-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.config.textPart3)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  class: "mt-4 mb-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: "mt-4 mb-4",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ActionButton, {
                "button-class": "answer-button text-left mt-2",
                rawtext: _ctx.$t(_ctx.config.options.answer1, {name: _ctx.state.nickname.value}),
                class: _normalizeClass({'active': _ctx.selectedAnswer === 'answer1'}),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.answer('answer1', {'answer1': _ctx.$t(_ctx.config.options.answer1)})))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" >")
                ]),
                _: 1
              }, 8, ["rawtext", "class"]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('texts.or')), 1),
              _createVNode(_component_ActionButton, {
                "button-class": "answer-button text-left",
                rawtext: _ctx.$t(_ctx.config.options.answer2, {name: _ctx.state.nickname.value}),
                class: _normalizeClass({'active': _ctx.selectedAnswer === 'answer2'}),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.answer('answer2', {'answer2': _ctx.$t(_ctx.config.options.answer2)})))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" >")
                ]),
                _: 1
              }, 8, ["rawtext", "class"])
            ])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-3 flex-col items-end align-bottom flex h-full min-h-50vh",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: contain; background-position: center center; background-repeat: no-repeat;`)
          }, null, 4)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}